import React from 'react';
import { connect } from 'react-redux';
import { Link, Route } from "react-router-dom";
import { CustomerPageRole, InvoicePageRole, MangePageRole, ReportPageRole, TicketPageRole, ServicePageRole, BillingPageRole, SettingPageRole } from '../component/UserPermission';

function ItemLinkSubMenu({isRoleAllow, path, children}) {
  return(
    <Route path={path} exact={path === '/'} children={({ match }) => (
      <li style={{display: !isRoleAllow ? "none" : null}} className={"nav-item dropdown " + (match != null ? 'nav-item-expanded nav-item-open' : '')}>
        {children}
      </li>
    )}/>
  )
}

function ItemLink({isRoleAllow, path, title, iconCls, badgeCls, badgeNumber}) {
  return (
    <Route
      path={path}
      exact={path === '/'}
      children={({ match }) => (
        <Link style={{display: !isRoleAllow ? "none" : null}} to={path} className="dropdown-item">
          {iconCls && <i className={iconCls + " position-left"} />}
          <span className="position-left">{title}</span>
          {badgeCls && badgeNumber > 0 && <span className={"badge align-self-center ml-auto " + badgeCls}>{badgeNumber}</span>}
        </Link>
      )}
    />
  )
}

class SideBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    const { userProfile, role_path } = this.props;
    return (
      <React.Fragment>
        <div className="navbar navbar-expand-md navbar-light">
          <div className="text-center d-md-none w-100">
            <button type="button" className="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-navigation">
              <i className="icon-unfold"></i>
            </button>
          </div>
              
          <div className="navbar-collapse collapse" id="navbar-navigation">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a href="/" className="navbar-nav-link">
                  <i className="icon-home4 mr-2"></i>
                  Dashboard
                </a>
              </li>

              <ItemLinkSubMenu isRoleAllow={MangePageRole.isShowSideBar(userProfile && userProfile.role)} path="/orders">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-stack3 mr-2"></i> <span>Quản Trị</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  <div className="dropdown-header">Sản phẩm</div>
                  <ItemLink iconCls="icon-list-unordered" isRoleAllow={MangePageRole.isShowProductList(userProfile && userProfile.role)} path={role_path+"/product/list"} title="Danh Sách" />
                  <div className="dropdown-header">Server</div>
                  <ItemLink iconCls="icon-list-unordered" isRoleAllow={MangePageRole.isShowDCServerList(userProfile && userProfile.role)} path={role_path+"/server/list"} title="Danh Sách" />
                </div>
              </ItemLinkSubMenu>

              <ItemLinkSubMenu isRoleAllow={InvoicePageRole.isShowSideBar(userProfile && userProfile.role)} path="/orders">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-calculator mr-2"></i> <span>Đơn Hàng</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  <div className="dropdown-header">Đơn Hàng</div>
                  <ItemLink iconCls="icon-list-unordered" isRoleAllow={InvoicePageRole.isShowInvoiceList(userProfile && userProfile.role)} path={role_path+"/invoice/all/payment-method/all"} title="Tất Cả Đơn Hàng" />
                  <ItemLink iconCls="icon-stack-empty" isRoleAllow={InvoicePageRole.isShowVATRequestInvoice(userProfile && userProfile.role)} path={role_path+"/invoice/vat_request/anew"} title="Yêu Cầu Xuất Hóa Đơn" />
                  <ItemLink iconCls="icon-coin-dollar" isRoleAllow={InvoicePageRole.isShowInvoiceDebtList(userProfile && userProfile.role)} path={role_path+"/invoice_debt/all"} title="Công Nợ" />
                  {InvoicePageRole.isShowSaleCommission(userProfile && userProfile.role) && <div className="dropdown-header">Thống kê</div>}
                  <ItemLink iconCls="icon-cash3" isRoleAllow={InvoicePageRole.isShowSaleCommission(userProfile && userProfile.role)} path={role_path+"/commission/report"} title="Huê hồng" />
                </div>
               
              </ItemLinkSubMenu>

              <ItemLinkSubMenu isRoleAllow={TicketPageRole.isShowSideBar(userProfile && userProfile.role)} path="/user/ticket">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-comment-discussion mr-2"></i> <span>Hỗ Trợ (24/7)</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right" data-submenu-title="Hỗ Trợ (24/7)">
                  <div className="dropdown-header">Ticket</div>
                  <ItemLink iconCls="icon-list-unordered mr-2" isRoleAllow={TicketPageRole.isShowTicketList(userProfile && userProfile.role)} path={role_path + "/ticket/all"} title="Danh Sách" />
                  {TicketPageRole.isShowTicketRateList(userProfile && userProfile.role) && <div className="dropdown-header">Thống kê điểm hỗ trợ</div>}
                  <ItemLink iconCls="icon-stars" isRoleAllow={TicketPageRole.isShowTicketRateList(userProfile && userProfile.role)} path={role_path + "/report/ticket_score/list"} title="Thống Kê Điểm Hỗ Trợ" />
                </div>
              </ItemLinkSubMenu>
              <ItemLinkSubMenu isRoleAllow={CustomerPageRole.isShowSideBar(userProfile && userProfile.role)} path="/customer">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-user-tie mr-2"></i> <span>Khách Hàng</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right" data-submenu-title="Khách Hàng">
                  <div className="dropdown-header">Khách Hàng</div>
                  <ItemLink iconCls="icon-list-unordered" isRoleAllow={CustomerPageRole.isCustomerList(userProfile && userProfile.role)} path={role_path + "/customer/all"} title="Danh Sách" />
                  <ItemLink iconCls="icon-magazine" isRoleAllow={CustomerPageRole.isProfileList(userProfile && userProfile.role)} path={role_path + "/customer/profile/list"} title="Bản Khai" />
                </div>
              </ItemLinkSubMenu>
              <ItemLinkSubMenu isRoleAllow={ReportPageRole.isShowSideBar(userProfile && userProfile.role)} path="/report">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-file-text mr-2"></i> <span>Báo Cáo</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right" data-submenu-title="Báo Cáo">
                  <div className="dropdown-header">Doanh Số</div>
                  <ItemLink iconCls="icon-pie-chart8" isRoleAllow={ReportPageRole.isShowAgencyAverageList(userProfile && userProfile.role)} path={role_path + "/report/agency/average/list"} title="Doanh Số Đại Lý" />
                  <div className="dropdown-header">Đơn Hàng</div>
                  <ItemLink iconCls="icon-stack-empty" isRoleAllow={ReportPageRole.isShowInvoiceWrongPriceList(userProfile && userProfile.role)} path={role_path + "/report/invoice/wrong/price/list"} title="Đơn Hàng Sai Giá" />
                </div>
              </ItemLinkSubMenu>
              <ItemLinkSubMenu isRoleAllow={ServicePageRole.isShowSideBar(userProfile && userProfile.role)} path="/service">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-cloud mr-2"></i> <span>Dịch vụ</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right" data-submenu-title="Dịch vụ">
                  <div className="dropdown-header">Dịch Vụ</div>
                  <ItemLink iconCls="icon-checkmark-circle" isRoleAllow={ServicePageRole.isShowServiceRunning(userProfile && userProfile.role)} path={role_path+"/service/running"} title="Đang Sử Dụng" />
                  <ItemLink iconCls="icon-loop4" isRoleAllow={ServicePageRole.isShowServicePending(userProfile && userProfile.role)} path={role_path+"/service/pending"} title="Dịch Vụ Pending" />
                  <ItemLink iconCls="icon-minus-circle2" isRoleAllow={ServicePageRole.isShowServiceExpired(userProfile && userProfile.role)} path={role_path+"/service/expired"} title="Suspend Do Hết Hạn" />
                  <ItemLink iconCls="icon-spam" isRoleAllow={ServicePageRole.isShowServiceSuspend(userProfile && userProfile.role)} path={role_path+"/service/suspend"} title="Suspend Do Vi Phạm" />
                  <ItemLink iconCls="icon-cancel-circle2" isRoleAllow={ServicePageRole.isShowServiceDeleted(userProfile && userProfile.role)} path={role_path+"/service/deleted"} title="Đã Xoá" />
                  {ServicePageRole.isDomainTracking(userProfile && userProfile.role) && <div className="dropdown-header">Rà Soát & Kiểm Tra</div>}
                  <ItemLink iconCls="icon-search4" isRoleAllow={ServicePageRole.isDomainTracking(userProfile && userProfile.role)} path={role_path+"/service/domain/tracking"} title="Rà Soát Tên Miền" />
                </div>
              </ItemLinkSubMenu>
              <ItemLinkSubMenu isRoleAllow={BillingPageRole.isShowSideBar(userProfile && userProfile.role)} path="/billing">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-cash3 mr-2"></i> <span>Thu Chi</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right" data-submenu-title="Thu Chi">
                  <div className="dropdown-header">Mã Thanh Toán</div>
                  <ItemLink iconCls="icon-coin-dollar" isRoleAllow={BillingPageRole.isShowBillingList(userProfile && userProfile.role)} path={role_path+"/billing/all"} title="Mã Thanh Toán" />
                  <div className="dropdown-header">Hóa Đơn Nạp Tiền</div>
                  <ItemLink iconCls="icon-cash4" isRoleAllow={BillingPageRole.isShowBillingInvoiceList(userProfile && userProfile.role)} path={role_path+"/billing-invoice/type/all/status/all"} title="Hóa Đơn Nạp Tiền" />
                </div>
              </ItemLinkSubMenu>
              <ItemLinkSubMenu isRoleAllow={SettingPageRole.isShowSideBar(userProfile && userProfile.role)} path="/settings">
                <a href="#" className="navbar-nav-link dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-gear mr-2"></i> <span>Cài Đặt</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right" data-submenu-title="Cài Đặt">
                  <div className="dropdown-header">Cài Đặt</div>
                  <ItemLink iconCls="icon-mobile2" isRoleAllow={SettingPageRole.isShowMobileVersionPage(userProfile && userProfile.role)} path={role_path+"/mobile_version/all"} title="App Version" />
                </div>
              </ItemLinkSubMenu>
            </ul>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path
});

const mapDispatch = (dispatch) => ({

});

export default connect(mapState, mapDispatch)(SideBar);